import { decodeJwt } from "@/utils/jwt";
import type { ScoutOtelToken } from "@/utils/jwt";
import type { AppGroup, IngestKey } from "@/models/manager";
import type { Account } from "@/models/user";

// Type definition for the user module vuex state object.
export interface UserState {
  token: string | undefined;
  parsedToken: ScoutOtelToken | undefined;
  userId: string | undefined;
  accountId: string | undefined;
  appGroupId: string | undefined;
  appGroupName: string | undefined;
  expiresAt: number | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  serviceGroups: AppGroup[] | undefined;
  stripeSetupIntentClientSecret: string | undefined;
  packageId: string | undefined;
  account: Account;
  serviceGroupIngestKeyMapping: Record<string, IngestKey[]> | undefined;
  serviceGroupIdSelected: string | undefined;
  ingestKeyIdSelected: string | undefined;
}

/**
 * Create a state object for the user module.
 * @returns A state object initialized for use in the user module.
 */
export function makeState(): UserState {
  const token =
    sessionStorage.getItem("userToken") ||
    localStorage.getItem("userToken") ||
    undefined;
  const parsedJwt = decodeJwt(token);
  return {
    token: parsedJwt ? token : undefined,
    parsedToken: parsedJwt,
    userId: parsedJwt?.user,
    expiresAt: parsedJwt?.ttl,
    appGroupId: parsedJwt?.grp,
    accountId: parsedJwt?.acc,
    appGroupName: undefined,
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    serviceGroups: undefined,
    stripeSetupIntentClientSecret: undefined,
    packageId: undefined,
    account: {},
    serviceGroupIngestKeyMapping: undefined,
    serviceGroupIdSelected: undefined,
    ingestKeyIdSelected: undefined,
  };
}
